import axios from 'axios'
import qs from 'qs'
import * as apiConstants from '../constants/api-constants'
import { CRITICAL_ERRORS } from '../constants/error-constants'
import siteUrl from '../utils/siteUrl'

export const axiosInstance = axios.create()

/**
 * Error emitter for dispatching API errors globally
 * @class ErrorEventEmitter
 * @extends {EventTarget}
 */
class ErrorEventEmitter extends EventTarget {
	/**
	 * Emits an error event with message and code
	 * @param {string|null} errorCode - The error code to look up in CRITICAL_ERRORS
	 * @param {string|null} customMessage - Custom error message as fallback
	 */
	emitError(errorCode, customMessage) {
		const message =
			(errorCode && CRITICAL_ERRORS[errorCode]) ||
			customMessage ||
			'Ha ocurrido un error inesperado'

		this.dispatchEvent(
			new CustomEvent('apiError', {
				detail: { message, errorCode },
			})
		)
	}
}

export const errorEmitter = new ErrorEventEmitter()

//Get ip Address
const holderVariables = {}
async function getIp() {
	if (holderVariables.ip) {
		return holderVariables.ip
	}
	if (sessionStorage.getItem('ipAddress')) {
		holderVariables.ip = sessionStorage.getItem('ipAddress')
		return holderVariables.ip
	}
	holderVariables.ip = new Promise(resolve => {
		axios
			.get(apiConstants.GET_IP_ADDRESS, { timeout: 5000 })
			.then(response => {
				sessionStorage.setItem('ipAddress', response.data.ip)
				resolve(response.data.ip)
			})
			.catch(() => {
				resolve('127.0.0.1')
			})
	})
	return holderVariables.ip
}

axiosInstance.interceptors.request.use(
	async config => {
		const tokenResponse = sessionStorage.getItem('ipAddress')
			? sessionStorage.getItem('ipAddress')
			: await getIp()
		config.headers['Ip-Address'] = tokenResponse
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// handle response error general case
axiosInstance.interceptors.response.use(
	response => {
		if (response?.data?.errorCode) {
			const { errorCode } = response.data
			if (CRITICAL_ERRORS[errorCode]) {
				errorEmitter.emitError(errorCode)
				return Promise.reject(new Error(CRITICAL_ERRORS[errorCode]))
			}
		}
		return response
	},
	error => {
		const originalRequest = error.config
		// Error
		const { response } = error

		if (!response) {
			return Promise.reject(error)
		}

		const { status, data } = response

		// Check for mapped error codes
		if (data?.errorCode && CRITICAL_ERRORS[data.errorCode]) {
			errorEmitter.emitError(data.errorCode)
			return Promise.reject(new Error(CRITICAL_ERRORS[data.errorCode]))
		}

		if (status === 401) {
			// Unauthorized request: maybe access token has expired!
			return refreshAccessToken(originalRequest)
		} else {
			return Promise.reject(error)
		}
	}
)

const refreshAccessToken = _originalRequest => {
	_originalRequest._retry = true

	const payload = qs.stringify({
		grant_type: 'refresh_token',
		client_id: apiConstants.CLIENT_ID,
		refresh_token: JSON.parse(localStorage.getItem('TOKEN_INFO')).refreshToken,
	})

	return axiosInstance
		.post(apiConstants.REFRESH_TOKEN, payload, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
			},
		})
		.then(response => {
			if (response.status === 200) {
				//Find and replace token data
				const _currentTokenData = JSON.parse(localStorage.getItem('TOKEN_INFO'))
				_currentTokenData['accessToken'] = response.data.access_token
				_currentTokenData['idToken'] = response.data.id_token

				//Set new token data
				localStorage.setItem('TOKEN_INFO', JSON.stringify(_currentTokenData))

				// Replace token in original request
				_originalRequest.headers.Authorization = response.data.id_token

				return axios(_originalRequest)
			} else {
				localStorage.removeItem('USER_INFO')
				localStorage.removeItem('TOKEN_INFO')
				window.location.href = siteUrl + '/'
			}
		})
		.catch(() => {
			localStorage.removeItem('USER_INFO')
			localStorage.removeItem('TOKEN_INFO')
			window.location.href = siteUrl + '/'
		})
}
